// The message editor moved into the one content editor. This page only points there.

import { Navigate } from "react-router-dom";

export default function Messages() {
  return <Navigate to="/admin/content?kind=email" replace />;
}
